import {library} from '@fortawesome/fontawesome-svg-core';
import {faSort, faSortDown, faSortUp, faToggleOff, faToggleOn} from '@fortawesome/pro-duotone-svg-icons';

library.add(faSort, faSortUp, faSortDown, faToggleOn, faToggleOff);
